import { forwardRef } from 'react';

import cn from 'classnames';

import ArrowLeft from '@publicImages/svg/arrow-left.svg?static';

import tagmanager from '@/tagmanager';

import styles from './BackSearchButton.module.scss';

type Props = {
  buttonText?: string;
  buttonTextShort?: string;
} & React.ComponentProps<'button'>;

export const BackSearchButton = forwardRef<HTMLButtonElement, Props>(
  ({ buttonText, buttonTextShort, className, onClick, ...props }, ref) => {
    const onBackClick: typeof onClick = (event) => {
      tagmanager.tracker.voyageDetails.trackOnBackClick(buttonText);

      onClick?.(event);
    };

    return (
      <button
        aria-label={buttonText}
        className={cn(styles.root, className)}
        onClick={onBackClick}
        type="button"
        {...props}
        ref={ref}
      >
        <ArrowLeft className={styles.icon} />
        <span className={styles.text}>{buttonText}</span>
        <span className={styles.textShort}>{buttonTextShort}</span>
      </button>
    );
  },
);

BackSearchButton.displayName = 'BackSearchButton';
